import { useEffect, useState } from "react";
import { FeatureGroup } from "react-leaflet";
import { TradePriceTileLayer } from "./TradePriceTileLayer";
import { TradePriceTileFilterControl } from "./TradePriceTileFilterControl";
import {
  type TradePriceTileFilter,
  DEFAULT_TRADE_PRICE_TILE_FILTER,
} from "../types/tradePrice";

interface Props {
  defaultVisible: boolean;
  initialZoomLevel: number;
  visible?: boolean;
  filter?: TradePriceTileFilter;
  onFilterChange?: (filter: TradePriceTileFilter) => void;
  onShowDetailList?: (location: {
    prefecture: string;
    municipality: string;
    districtName: string;
  }) => void;
}

export const TRADE_PRICE_LAYER_NAME = "取引価格（成約事例）を表示する";

/**
 * TradePriceTileLayerをLeafletのLayersControlで制御するためのWrapperコンポーネント
 */
export const TradePriceLayerControlWrapper: React.FC<Props> = ({
  defaultVisible,
  initialZoomLevel,
  visible: visibleProp,
  filter: filterProp,
  onFilterChange: onFilterChangeProp,
  onShowDetailList,
}) => {
  const [visible, setVisible] = useState(defaultVisible);
  const [internalFilter, setInternalFilter] = useState<TradePriceTileFilter>(
    DEFAULT_TRADE_PRICE_TILE_FILTER
  );
  // 外部からフィルターが渡される場合はそれを使用、そうでなければ内部状態を使用
  const filter = filterProp ?? internalFilter;
  const setFilter = onFilterChangeProp ?? setInternalFilter;

  useEffect(() => {
    if (typeof visibleProp === "boolean") {
      setVisible(visibleProp);
    }
  }, [visibleProp]);

  return (
    <>
      {/* 空のFeatureGroupは、LayersControlに認識させるために必要 */}
      <FeatureGroup />
      {visible && (
        <TradePriceTileFilterControl
          filter={filter}
          onFilterChange={setFilter}
        />
      )}
      <TradePriceTileLayer
        visible={visible}
        initialZoomLevel={initialZoomLevel}
        filter={filter}
        onShowDetailList={onShowDetailList}
      />
    </>
  );
};
